import * as t from "io-ts";
import {DatabaseCode, getDatabaseCode, toDatabaseCode} from "../database-code";

export type LocationMetaOriginSourceCode =
  "LAST_TRANSPORT" |
  "ACTIVE_GEOFENCE_EVENT" |
  "SHIFT_START_GEOFENCE_EVENT";

export interface LocationMetaOriginSource extends DatabaseCode {
  code: LocationMetaOriginSourceCode;
}

const lastTransport: LocationMetaOriginSource = {
  code: "LAST_TRANSPORT",
  displayValue: {
    id: "common.entity.location.meta.origin.source.lastTransport",
    defaultMessage: "Last transport"
  }
};

const activeGeofenceEvent: LocationMetaOriginSource = {
  code: "ACTIVE_GEOFENCE_EVENT",
  displayValue: {
    id: "common.entity.location.meta.origin.source.activeGeofenceEvent",
    defaultMessage: "Active geofence event"
  }
};

const shiftStartGeofenceEvent: LocationMetaOriginSource = {
  code: "SHIFT_START_GEOFENCE_EVENT",
  displayValue: {
    id: "common.entity.location.meta.origin.source.shiftStartGeofenceEvent",
    defaultMessage: "Shift-start geofence event"
  }
};

export const locationMetaOriginSource = {
  lastTransport,
  activeGeofenceEvent,
  shiftStartGeofenceEvent
};

export const locationMetaOriginSources = Object.values(locationMetaOriginSource);

export const toLocationMetaOriginSource = (code: string): LocationMetaOriginSource =>
  toDatabaseCode(code, locationMetaOriginSources);

export const getLocationMetaOriginSource = (code: string | undefined): LocationMetaOriginSource | undefined =>
  getDatabaseCode(code, locationMetaOriginSources);

export const LocationMetaOriginCodec = t.intersection([
  t.type({
    source: t.string,
    siteId: t.string,
    siteName: t.string,
  }),
  t.partial({
    siteCompanyId: t.string,
    siteCompanyName: t.string,
    latitude: t.number,
    longitude: t.number,
    transportId: t.string,
    transportType: t.string,
    transportDttm: t.number,
    geofenceEventId: t.string,
    geofenceInDttm: t.number,
    geofenceOutDttm: t.number,
  }),
]);

export const LocationMetaOriginArrayCodec = t.array(
  LocationMetaOriginCodec
);

export type LocationMetaOrigin = t.TypeOf<typeof LocationMetaOriginCodec>;
